










































































































import { Component, Prop, Model, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { BPopover } from 'bootstrap-vue'
import { GapLogEntry } from '@/store/modules/types'
import { GapLogType } from '@/store/modules/enums'

@Component({
  components: {
    BPopover
  },
  computed: mapState('gaps', ['subStatus', 'reasons'])
})
export default class GapStatusPopover extends Vue {
  @Model('change') readonly gap!: any
  id = 'sub-status-popover'
  comment = ''
  logType = GapLogType.OFFICE_CALL
  subStatusSelected = ''
  loading = false
  get target() {
    return this.id + '-target-' + this.gap.id
  }

  getsubStatus() {
    return this.$store.state.gaps.subStatus.filter(ss => {
      return ss.active == '1'
    })
  }

  getReasons(ss) {
    return this.$store.state.gaps.reasons.filter(r => {
      return r.subStatusId == ss && r.active == '1'
    })
  }

  getReason(id) {
    return this.$store.state.gaps.reasons.filter(r => {
      return r.id == id
    })[0]
  }

  getStatus(id) {
    return this.$store.state.gaps.status.filter(s => {
      return s.id == id
    })[0]
  }

  async save(subStatus, reason) {
    if (this.loading || !this.comment) return
    try {
      this.loading = true

      await this.$store.dispatch('gaps/saveSubStatus', {
        gapId: this.gap.id,
        subStatusId: subStatus.id,
        comment: ''
      })

      await this.$store.dispatch('gaps/saveReason', {
        gapId: this.gap.id,
        reasonId: reason.id
      })

      if (reason.statusId) {
        var status = this.getStatus(reason.statusId)
        if (status) {
          await this.$store.dispatch('gaps/saveStatus', {
            gapId: this.gap.id,
            statusId: reason.statusId,
            comment: ''
          })

          this.gap.statusId = reason.statusId
          this.gap.statusName = status.name
          this.gap.statusBackColor = status.backColor
        }
      }

      if (this.comment) {
        const entry: GapLogEntry = {
          gapId: this.gap.id,
          statusId: reason.statusId,
          subStatusId: subStatus.id,
          reasonId: reason.id,
          typeId: this.logType,
          comment: this.comment
        }
        await this.$store.dispatch('gaps/saveLog', entry)
      }

      this.gap.subStatusId = subStatus.id
      this.gap.subStatusName = subStatus.name
      this.gap.subStatusBackColor = subStatus.backColor
      this.gap.subStatusFontColor = subStatus.fontColor

      this.gap.reasonId = reason.id
      this.gap.reasonName = reason.name

      this.loading = false
      this.close()
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  }
  close() {
    if (this.loading) return
    this.$root.$emit('bv::hide::popover', this.id)
    this.$emit('closed')
  }
}
